import { FC, useContext } from "react";
import ModalConfig from "components/Modals/ModalConfig";
import Modal from "utils/hookedComponents/Modal";
import { useHomeGoogleB } from "./core/homeGoogleB.hook";
import { HomeContext } from "pages/Home";
import { Marketings } from "pages/Home/core/home.types";

const HomeGoogle: FC = () => {
  const homeContext = useContext(HomeContext);
  const { isVisible, showModal, hideModal, reference } = { ...homeContext };

  useHomeGoogleB({ showModal });

  return isVisible && hideModal ? (
    <Modal
      reference={reference}
      isVisible={isVisible}
      content={
        <ModalConfig marketing={Marketings.googlePlace} hideModal={hideModal} />
      }
    />
  ) : null;
};

export default HomeGoogle;
